import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Modal from 'LuxKit/Modal/Modal'
import CabinCategoriesModalContent from './CruiseCabinCategoriesModal'
import useCruiseCabinTypeLabels from 'hooks/Cruise/useCruiseCabinTypeLabels'

interface Props {
  modalCategories: Array<App.CruiseShipCabinCategory>
  cabinType: string
}

function CabinDetailsModal({ cabinType, modalCategories }: Props) {
  const intl = useIntl()
  const cabinTypeLabels = useCruiseCabinTypeLabels()
  const cabinTypeLabel = cabinTypeLabels[cabinType.toLowerCase()] ?? cabinType
  return <Modal
    title={intl.formatMessage({
      id: 'jJGfl5DrN5DuxblJvKzS',
      defaultMessage: '{cabinType} cabins',
      description: 'Modal title for cabin details with cabin type in the cruises section',
    }, { cabinType: cabinTypeLabel })}
    size="L"
  >
    <Group direction="vertical" gap={24}>
      {modalCategories.map((cabinCategory) => (
        <CabinCategoriesModalContent key={cabinCategory.id} cabinCategory={cabinCategory} />
      ))}
    </Group>
  </Modal>
}

export default CabinDetailsModal
